/*=========================================================================================
  File Name: passwordResets.js
  Description: Vuex store for all actions related to the password model reset and forgot
==========================================================================================*/
import axios from "axios";

const state = {
  passwordReset: null,
  error: null,
  tokenValid: null,
};

const actions = {
  async requestPasswordReset({ commit }, email) {
    commit("CLEAR_ERROR");
    try {
      await axios.post("/api/passwordresets/forgot-password", { email });
      return true;
    } catch (_e) {
      return true;
    }
  },

  async validateResetToken({ commit }, token) {
    commit("CLEAR_ERROR");
    try {
      await axios.get("/api/passwordresets/validate-reset-token", {
        params: { token },
      });
      commit("SET_TOKEN_VALID", true);
      return true;
    } catch (_e) {
      commit("SET_TOKEN_VALID", false);
      commit("SET_ERROR", "De link is ongeldig of verlopen.");
      return false;
    }
  },

  async resetPassword({ commit }, { token, password }) {
    commit("CLEAR_ERROR");
    try {
      await axios.post("/api/passwordresets/reset-password", {
        token,
        password,
      });
      return true;
    } catch (_e) {
      commit("SET_ERROR", "De link is ongeldig of verlopen.");
      return false;
    }
  },
};

const mutations = {
  SET_TOKEN_VALID(state, v) {
    state.tokenValid = v;
  },
  SET_ERROR(state, e) {
    state.error = e;
  },

  CLEAR_ERROR(state) {
    state.error = null;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
